import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../services/permission.service';

export interface PermissionRequirement {
  module: string;
  action: string;
}

export const permissionGuard: CanActivateFn = (route) => {
  const permission = inject(PermissionService);
  const router = inject(Router);

  const required = route.data?.['permission'] as PermissionRequirement | undefined;

  if (!required) {
    return true;
  }

  if (permission.hasPermission(required.module, required.action)) {
    return true;
  }

  return router.createUrlTree(['/dashboard']);
};
